import { useState, useRef, useEffect } from 'react'
import Searchbar from '../../components/Search'
import { Link } from 'react-router-dom';
import logo from '../../assets/SnaptaLogo.png'
import PushNotificationDialog from './PushNotificationDialog'
import useApiPost from '../hooks/postData';
import Loader from '../../assets/Loader.gif'
import { useSelector } from 'react-redux';
import NoData from '../../assets/NoData.png'
import Arrow from '../../assets/Showing_Arrow.png'

function PushNotification() {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState("10");
  const dropdownRef = useRef(null);
  const [activePage, setActivePage] = useState(1)
  const [isLoading, setIsLoading] = useState(false)
  const { data, refetch, postData } = useApiPost()
  const [search, setSearch] = useState("")

  const handleGetNotificationList = async () => {
    setIsLoading(true)
    try {
      const response = await postData("/all_user_notification_list", { page_no: activePage, per_page: selectedValue, search: search })
    } catch (error) {
    } finally {
      setIsLoading(false)
    }
  }

  console.log("Notification List !!!", data?.detail)

  useEffect(() => {
    handleGetNotificationList()
  }, [activePage, selectedValue, search, refetch]);

  const pagination = data?.pagination;
  const lastPage = pagination?.last_page || 1;
  const currentPage = pagination?.current_page
  const AllNotificationList = data?.detail || [];

  // handle Pagination 

  const handleSelect = (value) => {
    setSelectedValue(value);
    setIsDropdownOpen(false);
  };

  const [open, setOpen] = useState(false)
  const handleOpen = () => setOpen(true)
  const handleClose = () => {
    setOpen(false)
    handleGetNotificationList()
  }

  // To close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const options = ["10", "25", "50", "100"];
  const isSidebarOpen = useSelector((state) => state.sidebar.isOpen);


  return (
    <>
      {/* <div className='mb-10 pl-72'> */}
      <div className={`dark:bg-primary ${isSidebarOpen ? "xl:pl-20" : "xl:pl-72"}`}>
        <Searchbar />
        <div className='px-4 pb-10 xl:px-6'>

          {/* Title */}
          <div className="flex justify-between border-t-[#F2F2F2] py-3">
            <h2 className="text-[#000000] font-poppins text-xl font-semibold pt-3 dark:text-darkText">Notification List</h2>
          </div>

          {/* Navigation Path */}
          <div className="flex items-center justify-between overflow-x-hidden">
            <div className="flex items-center gap-2">
              <Link to="/dashboard"><h3 className="text-[#3A3A3A] font-poppins text-base dark:text-darkText font-semibold">Dashboard</h3></Link>
              <div className="rounded-full w-1 h-1 bg-[#E0E0E0]"></div>
              <h3 className="text-[#858585] font-poppins text-base">Notification List</h3>
            </div>
          </div>

          {/* Header Bar */}
          {/* <div className="border border-[#E3E3E3] dark:border-[#1F1F1F] rounded-lg overflow-hidden mt-8 mx-6"> */}
          <div className="border border-[#E3E3E3] dark:border-[#1F1F1F] rounded-lg mt-8 overflow-x-auto w-full">
            <div className='xl:overflow-x-auto lg:overflow-x-auto 2xl:overflow-hidden min-w-[1200px] '>
              <div className='min-w-max'>

                {/* Table Header */}
                <div className="flex px-4 py-3 pl-16 text-left border-b dark:border-b-[#1F1F1F] dark:bg-darkHeader bg-header1">
                  <div className="w-[8%] text-headerText font-poppins text-sm font-semibold">S.L </div>
                  <div className="w-[60%] text-headerText font-poppins text-sm flex place-items-center gap-2 font-semibold">LIST NOTIFICATIONS</div>
                  <div className="w-[10%] text-headerText font-poppins text-sm flex place-items-center gap-2 font-semibold">TIME</div>
                  {/* <div className='w-[10%] text-headerText font-poppins text-sm flex place-items-center gap-2 font-semibold'>DATE</div> */}
                </div>

                {/* Data Rows */}
                {isLoading ? (<div className='flex justify-center py-60'><img src={Loader} alt="loader" height={50} width={50} /></div>) :

                  (<>
                    {AllNotificationList?.length > 0 ?

                      (<>
                        {AllNotificationList?.map((notification, index) => (
                          <div key={notification.id} className={`${index % 2 === 0 ? 'bg-white dark:bg-primary' : 'bg-[#00162e0a] dark:bg-primary'} flex items-center dark:border-b-[#1F1F1F] px-4 py-3 pl-16 border-b last:border-0`}>

                            {/* Serial Number */}
                            <div className="w-[8%] text-[#000000] dark:text-darkText font-poppins text-sm">{(currentPage - 1) * selectedValue + index + 1}</div>

                            {/* Title */}
                            <div className="w-[60%] flex gap-3 place-items-center">
                              <div className='border rounded-md border-opacityGradient dark:border-[#1F1F1F]'>
                                <img src={logo} className="object-cover p-2 rounded-lg w-11 h-11" />
                              </div>
                              <h2 className='font-poppins text-[#000000] dark:text-darkText font-semibold text-sm'>
                                {notification.message[0].toUpperCase() + notification.message.slice(1)}
                              </h2>
                            </div>

                            {/* Description */}
                            <div className="w-[10%] flex gap-2 items-center">
                              <p className='text-[#8D8D8D] font-poppins text-sm dark:text-darkText'>{notification.time_ago}</p>
                            </div>
                          </div>
                        ))}
                      </>) :

                      (<>
                        <div className='flex flex-col justify-center py-32 2xl:py-36 place-items-center'>
                          <img src={NoData} alt="no data" className='w-96' />
                          <h2 className='font-poppins text-[#000000] text-sm font-semibold'>Don't have any data to show</h2>
                        </div>
                      </>)}
                  </>)}




                {/* Pagination and Results Count */}
                {AllNotificationList?.length > 0 &&
                  <div className="flex justify-between px-10 py-6 bg-white dark:bg-primary">
                    {/* Results Count */}
                    <div className="relative flex gap-2 place-items-center" ref={dropdownRef}>
                      {/* Dropdown Button */}
                      <div
                        className="border border-[#9C9C9C] dark:border-[#1F1F1F] rounded-xl flex gap-2 items-center px-3 py-1 cursor-pointer relative"
                        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                      >
                        <p className="text-[#9C9C9C] font-poppins">{selectedValue}</p>
                        <button>
                          <img src={Arrow} className="w-4 h-4" />
                        </button>
                      </div>

                      {/* Dropdown Menu - Positioned Above */}
                      {isDropdownOpen && (
                        <div className="absolute left-0 z-50 mb-2 bg-white border dark:border-[#1F1F1F] dark:bg-primary border-gray-300 rounded-lg shadow-lg bottom-full w-max">
                          {options.map((option) => (
                            <p
                              key={option}
                              className="px-4 py-2 text-sm cursor-pointer dark:text-darkText hover:bg-gray-100"
                              onClick={() => handleSelect(option)}
                            >
                              {option}
                            </p>
                          ))}
                        </div>
                      )}

                      {/* Results Text */}
                      <p className="text-[#484848] font-poppins text-sm dark:text-gray-500">Showing <span className="font-semibold text-[#000000] text-sm dark:text-darkText">{pagination?.total}</span> results</p>
                    </div>

                    {/* Pagination Buttons */}


                    <div className="flex items-center justify-center gap-1 mt-4">
                      {/* Previous Button */}
                      <button
                        onClick={() => setActivePage((prev) => Math.max(1, prev - 1))}
                        disabled={activePage === 1}
                        className={`text-[#000000] text-sm dark:text-darkText font-poppins px-3 py-1 rounded-full transition-all duration-200 
      ${activePage === 1 ? "opacity-50 cursor-not-allowed" : "hover:bg-gray-200 dark:hover:bg-slate-700"}`}
                      >
                        Previous
                      </button>


                      {/* Page Number Buttons */}
                      {Array.from({ length: 5 }, (_, i) => {
                        const startPage = Math.max(1, Math.min(activePage - 2, lastPage - 4));
                        const pageNum = startPage + i;
                        return pageNum <= lastPage ? (
                          <button
                            key={pageNum}
                            onClick={() => setActivePage(pageNum)}

                            className={`text-sm font-poppins px-3 py-1 rounded-full transition-all duration-200 
          ${activePage === pageNum ? "text-white bg-button-gradient" : "text-black dark:text-darkText hover:bg-gray-200 dark:hover:bg-slate-700 dark:hover-none"}`}

                          >
                            {pageNum}
                          </button>
                        ) : null;
                      })}

                      {/* Ellipsis + Last Page */}
                      {lastPage > 5 && activePage < lastPage - 2 && (
                        <>
                          <span className="px-2">...</span>
                          <button
                            onClick={() => setActivePage(lastPage)}

                            className={`text-sm font-poppins px-3 py-1 rounded-full transition-all duration-200 
          ${activePage === lastPage ? "text-white bg-button-gradient" : "text-black dark:text-darkText hover:bg-gray-200 dark:hover:bg-slate-700 dark:hover-none"}`}

                          >
                            {lastPage}
                          </button>
                        </>
                      )}

                      {/* Next Button */}
                      <button
                        onClick={() => setActivePage((prev) => Math.min(lastPage, prev + 1))}
                        disabled={activePage === lastPage}
                        // className={`px-3 py-1 rounded-lg font-medium text-sm ${
                        //   activePage === lastPage
                        //     ? 'bg-gray-300 dark:bg-[#444] text-gray-500 cursor-not-allowed'
                        //     : 'bg-gray-200 dark:bg-[#2D2D2D] text-black dark:text-white'
                        // }`}
                        className={`text-[#000000] text-sm dark:text-darkText font-poppins px-3 py-1 rounded-full transition-all duration-200 
      ${activePage === lastPage ? "opacity-50 cursor-not-allowed" : "hover:bg-gray-200 dark:hover:bg-slate-700"}`}
                      >
                        Next
                      </button>
                    </div>


                  </div>}
              </div>
            </div>
          </div>

        </div>
      </div>

      <PushNotificationDialog open={open} handleClose={handleClose} handleOpen={handleOpen} />
    </>
  )
}

export default PushNotification;
